export default [
  {
    label: "Alternative Text",
    value: "alternativeText"
  },
  {
    label: "Index",
    value: "index"
  },
  {
    label: "Structural Navigation",
    value: "structuralNavigation"
  },
  {
    label: "Display Transformability",
    value: "displayTransformability"
  },
  {
    label: "Long Description",
    value: "longDescription"
  },
];
